import AlarmTypeService from '@/services/alarmType.service.js';

class AlarmTypeRepository {

    async getAlarmTypes() {
        const res = await AlarmTypeService.getList();
        return res.data;
    }

}

export default new AlarmTypeRepository();